export default {"src":"/_next/static/media/arrow-right-red.e9b55a71.svg","height":512,"width":448};